import { createSelector } from "reselect";

export const barcodeQtyImportReducerSelector = createSelector(
  state => state.get("barcodeQtyImportReducer"),
  barcodeQtyImportReducer => barcodeQtyImportReducer
);

export const barcodeQtyImportJobSelector = createSelector(
  barcodeQtyImportReducerSelector,
  barcodeQtyImportReducer => barcodeQtyImportReducer.get("importJob")
);

export const hasErrorsSelector = createSelector(
  barcodeQtyImportReducerSelector,
  barcodeQtyImportReducer => barcodeQtyImportReducer.get("hasErrors")
);

export const dataSelector = createSelector(
  barcodeQtyImportReducerSelector,
  barcodeQtyImportReducer => barcodeQtyImportReducer.get("data")
);

export const fileUploadStatusSelector = createSelector(
  barcodeQtyImportReducerSelector,
  barcodeQtyImportReducer => barcodeQtyImportReducer.get("isUploadSuccesful")
);

export const barcodeQtyImportIsProcessingSelector = createSelector(
  barcodeQtyImportJobSelector,
  job => {
    if (!job) return false;
    const status = job.get("status");
    const stage = job.get("stage");
    return status === "processing" && stage !== "upload_complete";
  }
);

export const barcodeQtyImportProgressSelector = createSelector(
  barcodeQtyImportJobSelector,
  job => {
    if (!job) return null;
    return {
      status: job.get("status"),
      stage: job.get("stage"),
      total_rows: job.get("total_rows"),
      processed_rows: job.get("processed_rows"),
      progress_percentage: job.get("progress_percentage"),
      error_message: job.get("error_message"),
      redirect_url: job.get("redirect_url")
    };
  }
);
